import React from 'react';
export const PrivacyPolicy = () => {
  return <div className="w-full min-h-screen bg-[#000000] text-white" data-id="element-389">
      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-390">
        {/* Logo */}
        <div className="flex justify-center mb-12" data-id="element-391">
          <img src="https://cdn.magicpatterns.com/uploads/pPv8sZAUYxABkDBucNAnxU/esa.png" alt="Equip Sales Academy Logo" className="h-16 sm:h-20" data-id="element-392" />
        </div>

        {/* Content */}
        <h1 className="text-4xl sm:text-5xl font-black mb-8 text-center" data-id="element-393">
          Privacy Policy
        </h1>

        <div className="space-y-8 text-white/90 leading-relaxed" data-id="element-394">
          <section data-id="element-395">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-396">
              1. Information We Collect
            </h2>
            <p className="mb-4" data-id="element-397">
              Equip Sales Academy ("we," "our," or "us") collects information
              that you provide directly to us when you:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-398">
              <li data-id="element-399">Register for our services or create an account</li>
              <li data-id="element-400">Schedule a Sales OS Audit Call</li>
              <li data-id="element-401">Subscribe to our communications</li>
              <li data-id="element-402">Participate in our training programs</li>
              <li data-id="element-403">Contact us for support or inquiries</li>
            </ul>
            <p className="mt-4" data-id="element-404">
              This information may include your name, email address, phone
              number, company name, job title, and other business-related
              information.
            </p>
          </section>

          <section data-id="element-405">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-406">
              2. How We Use Your Information
            </h2>
            <p className="mb-4" data-id="element-407">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-408">
              <li data-id="element-409">Provide, maintain, and improve our services</li>
              <li data-id="element-410">Process your requests and transactions</li>
              <li data-id="element-411">Send you technical notices and support messages</li>
              <li data-id="element-412">Communicate with you about products, services, and events</li>
              <li data-id="element-413">Monitor and analyze trends, usage, and activities</li>
              <li data-id="element-414">Detect, prevent, and address technical issues</li>
              <li data-id="element-415">Personalize and improve your experience</li>
            </ul>
          </section>

          <section data-id="element-416">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-417">
              3. Information Sharing and Disclosure
            </h2>
            <p className="mb-4" data-id="element-418">
              We do not sell, trade, or rent your personal information to third
              parties. We may share your information only in the following
              circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-419">
              <li data-id="element-420">With your consent or at your direction</li>
              <li data-id="element-421">With service providers who perform services on our behalf</li>
              <li data-id="element-422">
                To comply with legal obligations or respond to legal requests
              </li>
              <li data-id="element-423">
                To protect the rights, property, and safety of Equip Sales
                Academy, our users, or others
              </li>
              <li data-id="element-424">
                In connection with a merger, acquisition, or sale of assets
              </li>
            </ul>
          </section>

          <section data-id="element-425">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-426">
              4. Data Security
            </h2>
            <p data-id="element-427">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the internet or electronic storage is 100%
              secure.
            </p>
          </section>

          <section data-id="element-428">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-429">
              5. Your Rights and Choices
            </h2>
            <p className="mb-4" data-id="element-430">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-431">
              <li data-id="element-432">Access and receive a copy of your personal information</li>
              <li data-id="element-433">Correct or update your personal information</li>
              <li data-id="element-434">Delete your personal information</li>
              <li data-id="element-435">Object to or restrict certain processing of your data</li>
              <li data-id="element-436">Opt-out of marketing communications</li>
            </ul>
          </section>

          <section data-id="element-437">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-438">
              6. Cookies and Tracking Technologies
            </h2>
            <p data-id="element-439">
              We use cookies and similar tracking technologies to collect
              information about your browsing activities and to provide you with
              a personalized experience. You can control cookies through your
              browser settings.
            </p>
          </section>

          <section data-id="element-440">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-441">
              7. Changes to This Privacy Policy
            </h2>
            <p data-id="element-442">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page and updating the "Last Updated" date.
            </p>
          </section>

          <section data-id="element-443">
            <h2 className="text-2xl font-bold mb-4 text-white" data-id="element-444">
              8. Contact Us
            </h2>
            <p data-id="element-445">
              If you have any questions about this Privacy Policy or our privacy
              practices, please contact us at:
            </p>
            <p className="mt-4" data-id="element-446">
              <strong data-id="element-447">Equip Sales Academy</strong>
              <br data-id="element-448" />
              Email: privacy@equipsales.io
            </p>
          </section>

          <div className="pt-8 border-t border-white/20 text-center text-white/60" data-id="element-449">
            <p data-id="element-450">Last Updated: January 14, 2026</p>
          </div>
        </div>

        {/* Back to Home Link */}
        <div className="mt-12 text-center" data-id="element-451">
          <a href="/" className="inline-flex items-center gap-2 text-white hover:text-white/80 transition-colors" data-id="element-452">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>;
};